module.exports = {
    app_url: 'https://api.dreamdriverstech.com',
    app_socket_url: 'https://dreamdriverstech.com',
    GOOGLE_MAP_API_KEY: 'AIzaSyDyoWZ1tWbWnX6SLdZMNohAz_FN7bGciCI',
    freeagent_base_url:"https://drivershareltd.freeagent.com/",
};
